/////------------pppp---//
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { db, storage } from "../firebase";
import {
  collection,
  getDocs,
  query,
  where,
  deleteDoc,
  doc,
  getDoc,
} from "firebase/firestore";
import { ref, deleteObject } from "firebase/storage";
import Navbar from "../components/Navbar";

const ViewApplications = () => {
  const { jobId } = useParams();
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [jobTitle, setJobTitle] = useState("");
 

  // Auth observer
  useEffect(() => {
    const auth = getAuth();
    const unsub = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser || null);
    });
    return () => unsub();
  }, []);

  // Fetch job title
  useEffect(() => {
    const fetchJobTitle = async () => {
      if (!jobId) return;
      try {
        const jobRef = doc(db, "jobs", jobId);
        const jobSnap = await getDoc(jobRef);
        if (jobSnap.exists()) {
          const data = jobSnap.data();
          const titleValue =
            data.title || data.jobTitle || data.name || data.position || "";
          setJobTitle(titleValue);
        } else {
          setJobTitle("");
        }
      } catch (e) {
        console.error("Error fetching job title:", e);
        setJobTitle("");
      }
    };
    fetchJobTitle();
  }, [jobId]);

  // Fetch applications
  useEffect(() => {
    const fetchApplications = async () => {
      if (!user || !jobId) return;
      setLoading(true);
      try {
        const appsRef = collection(db, "applications");
        const q = query(appsRef, where("jobId", "==", jobId));
        const snap = await getDocs(q);

        const data = snap.docs.map((d) => {
          const raw = d.data();
          const resolvedTitle = raw.title || raw.jobTitle || jobTitle || "";
          return { id: d.id, ...raw, resolvedTitle };
        });

        setApplications(data);
      } catch (err) {
        console.error("Error fetching applications:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchApplications();
  }, [user, jobId, jobTitle]);

  // Delete application & resume
  const handleDelete = async (app) => {
    const confirm = window.confirm(
      "Are you sure you want to delete this application?"
    );
    if (!confirm) return;

    try {
      if (app.resume || app.resumeUrl) {
        try {
          const pathOrUrl = app.resume || app.resumeUrl;
          const fileRef = ref(storage, pathOrUrl);
          await deleteObject(fileRef);
        } catch (fileErr) {
          console.warn(
            "Resume file might already be deleted or invalid path:",
            fileErr
          );
        }
      }

      await deleteDoc(doc(db, "applications", app.id));
      setApplications((prev) => prev.filter((a) => a.id !== app.id));
      alert("Application deleted successfully.");
    } catch (err) {
      console.error("Error deleting application:", err);
      alert("Failed to delete application.");
    }
  };

  const handleDownload = async (url) => {
    try {
      const response = await fetch(url, { mode: "cors" });
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "resume.pdf";
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error downloading file:", error);
      alert("Failed to download resume. Please try again.");
    }
  };

  return (
    <>
      <Navbar />
      <div className="p-6 relative">
        <h1 className="text-2xl font-bold mb-4">Applications</h1>

        {loading ? (
          <p>Loading...</p>
        ) : applications.length === 0 ? (
          <p>No applications yet.</p>
        ) : (
          applications.map((app) => (
            <div
              key={app.id}
              className="border p-4 mb-4 rounded shadow-md flex flex-col gap-2"
            >
              <p>
                <strong>Profile:</strong> {app.resolvedTitle || "—"}
              </p>
              <p>
                <strong>Name:</strong> {app.name || "—"}
              </p>
              <p>
                <strong>Email:</strong> {app.email || "—"}
              </p>
              <p>
                <strong>Phone:</strong> {app.phone || "—"}
              </p>
              <p>
                <strong>Resume:</strong>{" "}
                {app.resume || app.resumeUrl ? (
                  <>
                    <a
                      href={app.resume || app.resumeUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-500 underline mr-3"
                    >
                      View Resume
                    </a>
                    <button
                      onClick={() =>
                        handleDownload(app.resume || app.resumeUrl)
                      }
                      className="text-green-600 underline"
                    >
                      Download Resume
                    </button>
                  </>
                ) : (
                  "Not uploaded"
                )}
              </p>

              <button
                onClick={() => handleDelete(app)}
                className="mt-2 bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700 w-max"
              >
                Delete Application
              </button>
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default ViewApplications;




















